<div class="c-progress-spinner">
  <mat-spinner class="mat-spinner-color" [diameter]="28"></mat-spinner>
</div>
